export default {
  "de-DE": {
    "404": "Die Seite, die du suchst, konnte nicht gefunden werden.",
    "500": "Ein Fehler ist aufgetreten.",
    "btn001": "Zurück zur Startseite"
  },
  "en-GB": {
    "404": "The page you are looking for cannot be found.",
    "500": "An error has occurred.",
    "btn001": "Return to the home page."
  },
  "es-ES": {
    "404": "No se encuentra la página que buscas.",
    "500": "Se ha producido un error.",
    "btn001": "Volver a la página principal"
  },
  "fr-FR": {
    "404": "La page que vous recherchez est introuvable.",
    "500": "Une erreur est survenue.",
    "btn001": "Retour à la page d'accueil"
  },
  "it-IT": {
    "404": "La pagina che cerchi non è stata trovata.",
    "500": "Si è verificato un errore.",
    "btn001": "Pagina principale"
  },
  "ja-JP": {
    "404": "お探しのページが見つかりません",
    "500": "エラーが発生しました",
    "btn001": "トップに戻る"
  },
  "zh-TW": {
    "404": "無法顯示網頁",
    "500": "網頁發生錯誤",
    "btn001": "回到首頁"
  },
  "en-US": {
    "404": "The page you are looking for cannot be found.",
    "500": "An error has occurred.",
    "btn001": "Return to the home page."
  },
  "es-MX": {
    "404": "No se encuentra la página que buscas.",
    "500": "Hubo un error.",
    "btn001": "Volver a la página principal"
  },
  "fr-CA": {
    "404": "La page que vous recherchez est introuvable.",
    "500": "Une erreur est survenue.",
    "btn001": "Retour à la page d'accueil"
  },
  "pt-BR": {
    "404": "A página não foi encontrada.",
    "500": "Ocorreu um erro.",
    "btn001": "Voltar à página inicial."
  }
}